import { Component, OnInit } from '@angular/core';
declare function IsSigWebInstalled(): boolean;
declare function GetSigWebVersion(): string;
declare function isSigWeb_1_7_0_0_Installed(sigWebVer:any): boolean;
declare function  isSigWeb_1_6_4_0_Installed(sigWebVer:any):boolean;

@Component({
  selector: 'app-topaz-settings',
  templateUrl: './topaz-settings.component.html',
  styleUrls: ['./topaz-settings.component.scss']
})
export class TopazSettingsComponent implements OnInit {
  resetIsSupported = false;
  SigWeb_1_6_4_0_IsInstalled = false; 
  SigWeb_1_7_0_0_IsInstalled = false; 
  isInstalled = false;
  sigWebLink = "https://www.topazsystems.com/software/sigweb.exe";

  constructor() { }

  ngOnInit() {
    //this method check if the needed software is installed, but it doesnt check if the hardware is connected <3
    if (IsSigWebInstalled()) {
      this.isInstalled = true;
      var sigWebVer = '';
      try {
        sigWebVer = GetSigWebVersion();
        console.log('Signature Web Version is = '+sigWebVer);
      } catch (err) {
        console.log('Unable to get SigWeb Version: ' + err);
      }

      if (sigWebVer != '') {
        try {
          this.SigWeb_1_7_0_0_IsInstalled =
            isSigWeb_1_7_0_0_Installed(sigWebVer);
        } catch (err) {
          console.log(err);
        }
        if (this.SigWeb_1_7_0_0_IsInstalled) {
          this.resetIsSupported = true;
        } else {
          try {
            this.SigWeb_1_6_4_0_IsInstalled =
              isSigWeb_1_6_4_0_Installed(sigWebVer);
            //if SigWeb 1.6.4.0 is installed, then enable corresponding functionality
          } catch (err) {
            console.log(err);
          }
          if (this.SigWeb_1_6_4_0_IsInstalled) {
            this.resetIsSupported = true;
            var sigweb_link = document.createElement('a');
            sigweb_link.href =
              'https://www.topazsystems.com/software/sigweb.exe';
            sigweb_link.innerHTML =
              'https://www.topazsystems.com/software/sigweb.exe';
          } else {
            var sigweb_link = document.createElement('a');
            sigweb_link.href =
              'https://www.topazsystems.com/software/sigweb.exe';
            sigweb_link.innerHTML =
              'https://www.topazsystems.com/software/sigweb.exe';
          }
        }
      } else {
        //Older version of SigWeb installed that does not support retrieving the version of SigWeb (Version 1.6.0.2 and older)
        var sigweb_link = document.createElement('a');
        sigweb_link.href = 'https://www.topazsystems.com/software/sigweb.exe';
        sigweb_link.innerHTML =
          'https://www.topazsystems.com/software/sigweb.exe';
      }
    } else {
      alert(
        'Unable to communicate with SigWeb. Please confirm that SigWeb is installed and running on this PC.'
      );
    }
  }
}
